import type { HasKey } from "./types";

export default function objectGroupBy<K extends PropertyKey, T extends Record<string, HasKey<K>>>(
  obj: T,
  key: K,
  predicate?: (value: T[string]) => boolean,
): Record<T[string][K] & PropertyKey, Array<T[string]>> {
  const result = {} as Record<T[string][K] & PropertyKey, Array<T[string]>>;

  for (const itemKey in obj) {
    const item = obj[itemKey];

    if (predicate && !predicate(item)) {
      continue;
    }

    const discriminator = item[key];

    if (discriminator === undefined) {
      continue;
    }

    const discriminatorKey = discriminator as T[string][K] & PropertyKey;

    if (!result[discriminatorKey]) {
      result[discriminatorKey] = [];
    }

    result[discriminatorKey].push(item);
  }

  return result;
}
